import {
  Component, signal, input,
  output
} from "@angular/core";
import { CommonModule, TitleCasePipe } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DropdownModule } from "primeng/dropdown";
import { DatePickerModule } from "primeng/datepicker";
import { DialogModule } from "@angular/cdk/dialog";
import { OpenItemSelection } from "../../../open-items-list/open-items.component";
import { JobIssueWithDetails } from "../../../../../../../domains/jobIssues/models/JobIssueWithDetails";
import { BqaImageItem } from "../../../../../../../domains/media/components/images-modal/bqa-image-item";


@Component({
  selector: "print-view-issue-item",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DropdownModule,
    DatePickerModule,
    DialogModule,
    TitleCasePipe
  ],
  templateUrl: "./issue-item.component.html",
  styleUrls: ["./issue-item.component.scss"]
})
export class IssueItemComponent {
  issue = input.required<JobIssueWithDetails>();
  media = input<BqaImageItem[]>([]);
  openItemsSelectionType = input<OpenItemSelection>(OpenItemSelection.Room);
  imageError = output<void>();

  OpenItemSelectionEnum = OpenItemSelection;

  hasUnassignedVendorSelection: boolean = false;
  currentlyEditingVendorId = signal<number | null>(null);

  private titleCasePipe = new TitleCasePipe();

  isSelfAssigned() {
    return this.issue().isSelfAssigned;
  }

  onImageError(img: HTMLImageElement, placeholder: HTMLElement): void {
    img.hidden = true;
    placeholder.hidden = false;
    this.imageError.emit();
  }

  getPrimaryDisplayName() {
    if (this.openItemsSelectionType() === OpenItemSelection.Room) {
      return this.issue()?.areaName;
    } else if (this.openItemsSelectionType() === OpenItemSelection.Vendor) {
      let displayName: string | undefined = undefined;
      if (this.issue().assignedVendors && this.issue().assignedVendors.length > 0) {
        displayName = this.issue().assignedVendors
          .map(v => this.titleCasePipe.transform(v.vendorDetails.name))
          .join(", ");
      }
      return displayName;
    } else if (this.openItemsSelectionType() === OpenItemSelection.Type) {
      return this.issue().componentName;
    }

    throw new Error(`Unsupported open item selection type: ${this.openItemsSelectionType()}`);
  }
}
